import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hm'
})
export class HourMinutePipe implements PipeTransform {

  transform(value: any, showAbr: boolean = false): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);

    return (hours > 9 ? hours : `0${hours}`.slice(-2)) + (showAbr ? 'h' : '') + ':' + ((minutes) > 9 ? minutes : `0${minutes}`.slice(-2)) + (showAbr ? 'm' : '');
  }

}
